export default function ConditionalRenderer ({ children, conditions = [], match = "ALL" }) {
    if(match === "ALL") {
        return conditions.every(c => c === true) ? children : <></>
    } else {
        return conditions.some(c => c === true) ? children : <></>
    }
}